export factory from './factory';



// WEBPACK FOOTER //
// ./src/api/voting/index.js